import React from 'react';
import { Divider } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface DividerFieldProps {
    field: SurveyComponent;
}

const DividerField: React.FC<DividerFieldProps> = ({
    field,
}) => {
    return (
        <Divider
            sx={{
                my: 2,
                borderColor: 'divider',
            }}
        />
    );
};

export default DividerField;
